import { render, staticRenderFns } from "./vue-particles.vue?vue&type=template&id=4a621780"
import script from "./vue-particles.vue?vue&type=script&lang=js"
export * from "./vue-particles.vue?vue&type=script&lang=js"
import style0 from "./vue-particles.vue?vue&type=style&index=0&id=4a621780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports